import styled from 'styled-components';

export const StyledScrollableDiv = styled.div`
  overflow-y: scroll;
  padding-right: 20px;
  height: 628px;
  margin-bottom: 1rem;
`;
